import React, { Fragment, useState, useEffect} from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { saveCharacter } from '../../../actions/character';

const TargCalcModal = ({
    character: {
        character
    },
    saveCharacter,
    closeModal
}) => {

    const {
        TARG,
        athleticsLevel,
        athleticsExpertise,
        gravLevel,
        gravExpertise,
        waveLevel,
        waveExpertise
    } = character;

    var [finalTARG, updateFinalTARG] = useState(TARG);

    var [curMove, setCurMove] = useState(0);
    var [otherSituations, updateOtherSituations] = useState([
        {name: "Partial Cover", active: false},
        {name: "Lying Prone", active: false},
        {name: "Deflect", active: false},
        {name: "Flying", active: false},
        {name: "Refract", active: false}
    ]);

    const updateMovement = () => e => {
        setCurMove(e.target.value);

        calculateCurrentTARG();
    }

    const toggleOtherSituation = () => e => {

        var selectedSitchInd = e.target.id;

        otherSituations[selectedSitchInd].active = !otherSituations[selectedSitchInd].active;

        var updatedArray = [...otherSituations];

        updateOtherSituations(updatedArray);

        calculateCurrentTARG();

    }

    const calculateCurrentTARG = () => {

        var targFromSitch = 0;

        if(otherSituations.find(x => x.name == "Partial Cover").active){ targFromSitch = targFromSitch + 3;}
        if(otherSituations.find(x => x.name == "Lying Prone").active){ targFromSitch = targFromSitch + 2;}
        if(otherSituations.find(x => x.name == "Deflect").active){ targFromSitch = targFromSitch + 4;}
        if(otherSituations.find(x => x.name == "Flying").active){ targFromSitch = targFromSitch + 2;}
        if(otherSituations.find(x => x.name == "Refract").active){ targFromSitch = targFromSitch + 4;}

        // If character is has skyrunner level 50, this calc changes but only when flying (Need to create code)
        var targFromMove = Math.floor(curMove / 5);

        updateFinalTARG(TARG + targFromMove + targFromSitch);
    }

    const submitTarg = () => e => {
        saveCharacter({
            ...character,
            "curTARG": finalTARG
        });

        closeModal();
    }

    // Can we make the movement range dynamic based on unlocked perks? Does movement already update?

    return (
        <Fragment>
            <div className="targModalPanel">
                <div className="targModalTop">
                    <h1 className="mar-1 text-blue">Calculate TARG</h1>
                    <div className='closeAttackModal' onClick={e=>closeModal()(e)}>X</div>
                </div>
                <h2 className='pad-1'>Enter the following information based on your last turn.</h2>
                <div className="movementContainer">
                    <div className="moveRow">
                        <div>Total Movement</div><div className="curMove">{curMove}</div>
                    </div>
                    <div className="moveRow">
                        <input className="movSlider" id="movSlider" name="movSlider" defaultValue="0" type='range' min="0" max="40" onChange={e => updateMovement()(e)}/>
                    </div>
                </div>
                <div className="otherContainer">
                    <div id={0} className={otherSituations[0].active ? "targBut selected" : "targBut"} onClick={e => toggleOtherSituation()(e)}>Partial Cover</div>
                    <div id={1} className={otherSituations[1].active ? "targBut selected" : "targBut"} onClick={e => toggleOtherSituation()(e)}>Lying Prone</div>
                    {gravLevel >= 20 && <div id={2} className={otherSituations[2].active ? "targBut selected" : "targBut"} onClick={e => toggleOtherSituation()(e)}>Deflect</div>}
                    {gravLevel >= 35 && gravExpertise == "Skyrunner" && <div id={3} className={otherSituations[3].active ? "targBut selected" : "targBut"} onClick={e => toggleOtherSituation()(e)}>Flying</div>}
                    {waveLevel >= 15 && <div id={4} className={otherSituations[4].active ? "targBut selected" : "targBut"} onClick={e => toggleOtherSituation()(e)}>Refract</div>}
                </div>
                <div className="finalTargRow">
                    <div className="finalTarg">Final TARG: {finalTARG}</div>
                    <div className="submitBut" onClick={e => submitTarg()(e)}>SUBMIT</div>
                </div>
            </div>
        </Fragment>
    )
}

TargCalcModal.propTypes = {
    character: PropTypes.object.isRequired,
    closeModal: PropTypes.func.isRequired,
    saveCharacter: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
    character: state.character
});

export default connect(mapStateToProps, {saveCharacter})(TargCalcModal);